<template>
  <div class="page block">
    <div class="page__wrapper block-wrapper" v-if="result">
      <div class="page__header">
        <div class="page__title">
        </div>
      </div>
      <div class="page__body">
        <div class="queue">
          <div class="queue__wrapper">
            <div class="queue__item">
              <div class="queue__text">
                {{ successMessage }}
              </div>
              <div class="queue__text" style="padding-top: 10px">
                {{ $t('successRegistration.visit.title') }}
              </div>
              <ol class="queue__list">
                <li v-for="i in range" :key="i" class="queue__list_item">
                  {{ $t(`successRegistration.visit.item${i}`) }}
                </li>
              </ol>
            </div>
            <div class="queue__item">
              <div class="queue__text">
                <a class="queue__text_link" @click="back">{{ $t('successRegistration.back') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Helper from '@/utils/helper'

export default {
  name: 'SuccessRegistration',
  data() {
    return {
      success: null
    }
  },
  computed: {
    ...mapState({
      apiKey: state => state.app.apiKey,
      result: state => state.app.registration
    }),
    successMessage() {
      const successMessage = this.$t('successRegistration.success', this.success)
      if (this.success && this.success.name) {
        const name = this.success.name
        return name + ', ' + successMessage.charAt(0).toLowerCase() + successMessage.slice(1)
      }
      return successMessage
    },
    range() {
      return Helper.range(1, 4)
    }
  },
  methods: {
    back() {
      if (this.apiKey) {
        this.$pageManager.showRegistratorForm({}, {
          key: this.apiKey
        })
      }
    }
  },
  mounted() {
    if (this.result.name || this.result || this.result.vizitDateValue || this.result.times || this.result.fullAddress) {
      this.success = {
        name: this.result.name,
        date: this.result.vizitDateValue,
        time: this.result.times,
        address: this.result.fullAddress
      }
    }
  }
}
</script>
